import React, { useState } from 'react';
import Draggable from "react-draggable";
import { useDispatch, useSelector } from 'react-redux';
import { css, styled } from 'styled-components';
import { setDice, setDiceAct } from '../../../store/GameSlice';
import { Dice } from '../../_atoms/Dice';
import { GameInfo } from '../../_molecules/GameInfo';

const Piece = styled.div`
  display : block;
  background: center /contain no-repeat;
  filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.4));
  position: absolute;
  bottom: 2.5%;
  z-index: 0;
  
  ${(props) => props.type === 'rabbit' && !props.rabbit && css`
    animation: rabbit 1s ease-in-out infinite;
    transition-timing-function: cubic-bezier(0.17, 0.67, 0.51, 1);

    @keyframes rabbit {
      0% {
        transform: translate(${(props) => props.pos.x}px, ${(props) => props.pos.y}px) scale(100%);
      }

      50% {
        transform: translate(${(props) => props.pos.x}px, ${(props) => props.pos.y}px) scale(95%);
      }

      100% {
        transform: translate(${(props) => props.pos.x}px, ${(props) => props.pos.y}px) scale(100%);
      }
    }
  `}
    
  ${(props) => props.type === 'fox' && !props.fox && css`
    animation: fox 1s ease-in-out infinite;
    transition-timing-function: cubic-bezier(0.17, 0.67, 0.51, 1);
    
    @keyframes fox {
      0% {
        transform: translate(${(props) => props.pos.x}px, ${(props) => props.pos.y}px) scale(100%);
      }

      50% {
        transform: translate(${(props) => props.pos.x}px, ${(props) => props.pos.y}px) scale(95%);
      }

      100% {
        transform: translate(${(props) => props.pos.x}px, ${(props) => props.pos.y}px) scale(100%);
      }
    }
  `}
  
  ${(props) => props.type === 'sheep' && !props.sheep && css`
    animation: sheep 1s ease-in-out infinite;
    transition-timing-function: cubic-bezier(0.17, 0.67, 0.51, 1);
    
    @keyframes sheep {
      0% {
        transform: translate(${(props) => props.pos.x}px, ${(props) => props.pos.y}px) scale(100%);
      }

      50% {
        transform: translate(${(props) => props.pos.x}px, ${(props) => props.pos.y}px) scale(95%);
      }

      100% {
        transform: translate(${(props) => props.pos.x}px, ${(props) => props.pos.y}px) scale(100%);
      }
    }
  `}

  &:hover {
    cursor: move;
    animation: unset;
  }

  &:active {
    transform: scale(120%);
  }

  ${(props) => {
    switch (props.type) {
      case 'rabbit':
        return css`
          left: 3%;
          width: 91px;
          height: 148px;
          background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/game/game_rabbit.png);
        `
      case 'fox':
        return css`
          left: calc(3% + 91px);
          width: 91px;
          height: 131px;
          background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/game/game_fox.png);
        `
      case 'sheep':
        return css`
          left: calc(3% + 182px);
          width: 101px;
          height: 125px;
          background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/game/game_sheep.png);
        `
      default:
        break;
    }
  }}
`;

export const GameWrap = () => {
  const state= useSelector((state) => state);
  const dispatch = useDispatch();

  const [rabbit, setRabbit] = useState(false);
  const [fox, setFox] = useState(false);
  const [sheep, setSheep] = useState(false);

  const [rabbitPos, setRabbitPos] = useState({x : 0, y: 0});
  const [foxPos, setFoxPos] = useState({x : 0, y: 0});
  const [sheepPos, setSheepPos] = useState({x : 0, y: 0});

  const rabbitHandleDrag = (e, data) => {
    setRabbitPos({ x: data.x, y: data.y });
  };
  
  const foxHandleDrag = (e, data) => {
    setFoxPos({ x: data.x, y: data.y });
  };

  const sheepHandleDrag = (e, data) => {
    setSheepPos({ x: data.x, y: data.y });
  };

  const onDiceClick = () => {
    dispatch(setDice(Math.floor(Math.random() * (6 - 1) + 1)));
    dispatch(setDiceAct(true));
  };

  return (
    <>
      <Dice onClick={onDiceClick}/>
      <GameInfo />
      <Draggable bounds='parent' position={rabbitPos} onDrag={rabbitHandleDrag} scale={state.common.zoom}>
        <Piece pos={rabbitPos} rabbit={rabbit} type="rabbit" onMouseEnter={() => setRabbit(true)} onMouseLeave={() => setRabbit(false)} />
      </Draggable>
      <Draggable bounds='parent' position={foxPos} onDrag={foxHandleDrag} scale={state.common.zoom}> 
        <Piece pos={foxPos} fox={fox} type="fox" onMouseEnter={() => setFox(true)} onMouseLeave={() => setFox(false)} />
      </Draggable>
      <Draggable bounds='parent' position={sheepPos} onDrag={sheepHandleDrag} scale={state.common.zoom}>
        <Piece pos={sheepPos} sheep={sheep} type="sheep" onMouseEnter={() => setSheep(true)} onMouseLeave={() => setSheep(false)}/>
      </Draggable>
    </>
  );
};